let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3Rau7")).then(() => parcelRequire('daQ47'));